
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/corporateSignupConfig.reducers';

export const selectDataState = createFeatureSelector<State>('corporateSignupConfigData');

export const selectCorporateSignupConfigData = createSelector(selectDataState, (state) => state.corporateSignupConfigData);
export const selectCorporateSignupConfigLoading = createSelector(selectDataState, (state) => state.loading);
export const selectCorporateSignupConfigError = createSelector(selectDataState, (state) => state.error);
